import React, { Component } from "react";
import { Link } from 'react-router-dom';


class ProviderPortalDoc extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeSection: null,
            expandedSection: null,
        };
    }

    componentDidMount() {
        this.smoothScrollTo();
    }

    toggleSection = (section) => {
        this.setState((prevState) => ({
            expandedSection: prevState.expandedSection === section ? null : section,
        }));
    };

    toggleTOCSection = (section) => {
        this.setState((prevState) => ({
            activeSection: prevState.activeSection === section ? null : section,
        }));
    };

    renderSubItems(items) {
        return (
            <ul className="pl-4">
                {items.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>
        );
    }

    smoothScrollTo(id) {
        if (id) {
            var section = document.getElementById(id);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });

            }
        } else {
            const id = localStorage.getItem("id");
            console.log(id);

            if (id) {
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                }
            }
        }
    }

    render() {
        const { expandedSection, activeSection } = this.state;

        const sections = [
            {
                title: "1. MyJEEVA PROVIDER PORTAL OVERVIEW",
                id: "sec1",
                subItems: [
                    "1.1 Provider Portal Roles",
                    "1.2 Provider Portal Workflow",
                    "1.3 Treatments",
                    "1.4 Patient Healthcare Journey",
                ],
            },
            {
                title: "2. GETTING STARTED",
                id: "sec2",
                subItems: [
                    "2.1 Set Up Your Profile",
                    "2.2 Update External Contact Information",
                    "2.3 Create Treatment Passphrases",
                    "2.4 Configure Notification Preferences",
                    "2.5 Set Up Two-Factor Authentication (2FA)",
                    "2.6 Log Out and Session Management",
                    "2.7 Reset Your Password",
                ],
            },
            {
                title: "3. ENGAGE PATIENTS",
                id: "sec3",
                subItems: [
                    "Onboard Patients",
                    "Assign Additional Treatments to Patients",
                    "Access Patient Data",
                    "Add Patient Milestone Dates",
                ],
            },
            {
                title: "4. IDENTIFY PATIENTS AT RISK",
                id: "sec4",
            },
            {
                title: "5. CREATE OR MODIFY A TREATMENT",
                id: "sec5",
                subItems: [
                    "Treatment Creation Overview",
                    "Select Treatment",
                    "Create Treatment Library Content",
                    "Define Risk Parameters",
                    "Create Milestones",
                    "Create Journals",
                    "Create Surveys",
                    "Create Risk Rules",
                ],
            },
            {
                title: "6. MyJEEVA ADMINISTRATORS",
                id: "sec6",
                subItems: [
                    "Onboarding and Removing Users",
                    "Assigning Treatments",
                    "Service Line Administrators",
                    "Hospital Administrators",
                    "Health System Administrators",
                ],
            },
            {
                title: "7. TECHNICAL REQUIREMENTS",
                id: "sec7",

            },
            {
                title: "8. SUPPORT",
                id: "sec8",

            },
            {
                title: "9. COPYRIGHT AND LEGAL NOTICES",
                id: "sec9",

            },
        ];

        return (
            <div
                style={{
                    //   position: "absolute",
                    //   top: "0",
                    //   left: "0",
                    //   width: "100vw",
                    //   height: "100vh",
                    // backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 999,
                }}>
                <div
                    style={{
                        position: "relative",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        padding: "35px",
                        zIndex: 1000,
                        // width: "auto",
                    }}
                >

                    <h1 className="text-xl font-bold mb-4" style={{ color: "#282a65" }}>
                        MyJEEVA Provider Portal User Documentation
                    </h1>
                    <p className="mb-4">Last modified: Jan 14, 2025</p>

                    {/* Table of Contents */}
                    <ul className="list-disc pl-6"
                        style={{ listStyle: "none", paddingLeft: 0 }}
                    >
                        {sections.map((section, index) => (
                            <li key={index}>
                                <div
                                    onClick={() => this.toggleTOCSection(index)}
                                    className="cursor-pointer text-blue-600 hover:underline"
                                    style={{ color: "#282a65", }}
                                >
                                    <a href="#" onClick={(e) => { e.preventDefault(); this.smoothScrollTo(section.id); }}>
                                        {section.title}
                                    </a>

                                </div>
                                {activeSection === index &&
                                    section.subItems &&
                                    this.renderSubItems(section.subItems)}
                            </li>
                        ))}
                    </ul>

                    <hr></hr>
                    {/* Detailed Documentation Sections */}
                    <div id="sec1" style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>
                        <h2
                            // onClick={() => this.toggleSection(1)}
                            style={{ color: "#282a65", }}
                        >
                            1. MyJEEVA PROVIDER PORTAL OVERVIEW
                        </h2>
                        {/* ( */}


                        <p>
                            The MyJEEVA solution is an advanced healthcare solution designed
                            to:
                        </p>
                        <ul>
                            <li>
                                Enhance quality of home-based care for patients through
                                personalized content management, medication tracking, surveys,
                                and virtual agents.
                            </li>
                            <li>
                                Collect provider-defined data regarding patients’ home-based
                                recovery journeys.
                            </li>
                            <li>
                                Assess patients’ risk based on provider-defined risk parameters.
                            </li>
                        </ul>
                        <p>
                            MyJEEVA consists of three main components: Provider Portal,
                            Patient Application, and Cloud Infrastructure.
                        </p>

                        <h3 onClick={() => this.toggleSection(1.1)} style={{ color: "#282a65", }}
                        >
                            1.1 Provider Portal Roles
                        </h3>
                        {/* {expandedSection === 1.1 && */}

                        {/* ( */}
                        <div>
                            <p>There are four roles available:</p>
                            <ul>
                                <li>
                                    <b>Health System Administrator:</b> Manages hospitals and
                                    invites administrators.
                                </li>
                                <li>
                                    <b>Hospital Administrator:</b> Manages service lines and
                                    invites administrators.
                                </li>
                                <li>
                                    <b>Service Line Administrator:</b> Manages service line
                                    treatments and invites clinical teams.
                                </li>
                                <li>
                                    <b>Provider:</b> Monitors patient risk, updates patient
                                    milestones, and customizes treatments.
                                </li>
                            </ul>
                        </div>
                        {/* ) */}
                        {/* } */}

                        <h3
                            style={{ color: "#282a65", }}
                        >
                            1.2 Provider Portal Workflow
                        </h3>
                        {/* {expandedSection === 1.2 && */}
                        {/* ( */}
                        <div>
                            <p>The five primary workflow phases include:</p>
                            <ul>
                                <li>Set up profile:  Configure provider information that is shared with patients in the MyJEEVA application. This is a one-time process that only takes a few minutes.  See section 2 for more information</li>
                                <li>Onboard patients:  Help patients download the MyJEEVA application and share treatment QR code or passphrase.  This is a one-time process for each MyJEEVA treatment assigned to a patient and only takes 1-2 minutes.  See section 3 for more information.</li>
                                <li>Update milestones:  If a treatment uses milestones for date-based journals, surveys, or risk rules, providers must document dates of treatment milestones for patients.  See section 3 for more information.  This is a one-time data entry for each patient milestone (e.g., surgery date) for a MyJEEVA treatment and only takes a minute.  See section 3 for more information.</li>
                                <li>Manage risk:  Monitor the MyJEEVA patient risk dashboard to identify patients that may be having an anomalous health journey and proactively manage those patients as required.  Monitoring </li>
                                <li>Check data for patient reported outcomes (PRO):  When a patient has an appointment or calls in to the care team, it may be beneficial to check historical PRO data from the MyJEEVA journals and surveys.  This is a periodic activity that only takes a few minutes.  See section 3 for more information.</li>
                            </ul>
                            <p>Each of the steps of the MyJEEVA workflow are easy to learn and quick to execute.  These few minutes provide a dramatic payback in terms of patient outcomes and care team productivity.</p>
                        </div>
                        {/* ) */}
                        {/* } */}

                        <h3
                            style={{ color: "#282a65", }}

                        // onClick={() => this.toggleSection(1.3)}

                        >1.3 Treatments</h3>
                        {/* {expandedSection === 1.3 &&  */}
                        {/* ( */}
                        <div>
                            <p>Treatments play a central role in the MyJEEVA solution.  MyJEEVA treatments can be created to address many use cases, such as</p>
                            <ul>
                                <li>Pre- and post-operative treatment journeys</li>
                                <li>Chronic disease management</li>
                                <li>High-complication heath care services</li>
                                <li>Clinical trial data collection and support</li>
                                <li>Wellness and preventative services</li>
                                <li>Patient on-boarding</li>
                            </ul>
                            <p>Traditional medical definition for comparison:  provision, coordination or management of health care and related services by one or more health care providers
                            </p>

                            <p>For the purposes of the MyJEEVA service, a treatment can be thought of as a collection of patient-facing and provider-only services to facilitate the educational and risk management needs of a patient in an out-patient environment.</p>
                            <p>There are three primary patient-facing components and two provider-only treatment components:
                            </p>
                            <h2>Provider and Patient-facing (via the MyJEEVA patient application)</h2>

                            <h3>Library:</h3>
                            <p>
                                Provider-defined content to educate and instruct patients through their treatment journey.
                                This content can be text, pictures, audio, or video and is organized in a hierarchical structure
                                to facilitate access and comprehension by patients and caregivers.
                            </p>

                            <h3>Journals (optional):</h3>
                            <p>
                                Digital, provider-defined journals to enable patients to easily document a patient's recovery journey.
                                Journals can be configured to document bio-markers and/or psycho-markers.
                                Journal entries are reflected in the MyJEEVA Provider Portal in real-time.
                            </p>

                            <h3>Surveys (optional):</h3>
                            <p>
                                Digital, provider-defined surveys to enable patients to provide feedback about their recovery journey.
                                Survey entries are reflected in the MyJEEVA Provider Portal in real-time.
                            </p>

                            <h2>Provider-only</h2>

                            <h3>Risk rules (optional):</h3>
                            <p>
                                Risk rules help identify high- and moderate-risk patients.
                                Journal data is assessed in real-time against provider-defined risk parameters.
                            </p>
                            <p>Risk rules are defined at the treatment level.</p>
                            <p>
                                If a high-risk rule is triggered, a provider-defined message will be sent to the
                                MyJEEVA application of the patient.
                            </p>

                            <h3>Milestones (optional):</h3>
                            <p>
                                Milestones are used to create time-based dependencies for journals, surveys, and risk rules
                                (e.g., display a journal to patients on their surgery date and the next 10 days).
                                A treatment can have multiple milestones.
                            </p>
                            <p>Milestones are defined at the treatment level.</p>
                            <p>
                                Milestone offsets establish time-based criteria for journals and surveys.
                                They establish a relative time band that is applied to the patient-specific milestones.
                            </p>
                            <p>
                                Patient-specific milestone dates are not officially part of a treatment, but are entered manually
                                by care teams to fix milestone-based journals, surveys, and risk rules to specific dates.
                            </p>

                            <h2>Engagements Section</h2>
                            <p>Your treatments are accessible in the Engagements section of the MyJEEVA Provider Portal.</p>

                            <h3>There are two categories of treatments:</h3>

                            <h4>Administrative treatments:</h4>
                            <p>
                                These treatments are defined by your service line administrator and are displayed with a blue background.
                                Generally, all providers within a service line will have access to the same standardized administrative treatments.
                                Administrative treatments are fully functional but may only be modified by service line administrators.
                            </p>

                            <h4>Custom treatments:</h4>
                            <p>
                                These treatments have been cloned from an existing treatment and modified by you.
                                All five treatment components of a provider-treatment can be customized based on the provider’s medical perspectives.
                                They are displayed with a white background. Custom treatments can only be utilized by the provider that created them.
                            </p>

                            <p>
                                For more information on the creation, modification, structure, and content of treatments, see section 5.
                            </p>
                        </div>
                        {/* ) */}
                        {/* } */}

                        <h3 onClick={() => this.toggleSection(1.4)} style={{ color: "#282a65", }}
                        >
                            1.4 Patient Healthcare Journey
                        </h3>
                        {/* {expandedSection === 1.4 && ( */}


                        <div>
                            <h2>1.4 Insight into Patient Healthcare Journey</h2>

                            <p>
                                MyJEEVA provides insight into patients’ healthcare journeys through two primary mechanisms:
                            </p>

                            <ul>
                                <li>
                                    <strong>Patient-specific data captured in treatment journals and surveys (PRO):</strong> These reports
                                    provide the detailed data necessary to assess a patient’s status outside a clinical environment and
                                    identify trends.
                                </li>
                                <li>
                                    <strong>Synthesized reports and dashboards based on aggregation and/or analysis of treatment journals:</strong>
                                    Dashboards and reports are valuable to identify at-risk patients and enable proactive mitigation strategies
                                    for emerging complications.
                                </li>
                            </ul>

                            <p>
                                Dashboards and reports are available on the MyJEEVA Provider Portal for each treatment in which a patient is
                                enrolled. For example, if a patient is enrolled in three treatments, there will be three line items for the
                                patient in the risk dashboard.
                            </p>

                            <h3>Role-Based Data Availability</h3>

                            <table border="1" cellPadding="10" style={{ borderCollapse: 'collapse', width: '100%' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#f2f2f2' }}>
                                        <th>Role</th>
                                        <th>Available PRO</th>
                                        <th>Available Reports</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Provider</td>
                                        <td>
                                            <ul>
                                                <li>Journal data</li>
                                                <li>Survey responses</li>
                                                <li>Medication adherence</li>
                                                <li>Interactions with artificial intelligence agent (coming soon)</li>
                                            </ul>
                                        </td>
                                        <td>
                                            <ul>
                                                <li>Risk dashboard</li>
                                                <li>Journal data relevant to risk rule triggers</li>
                                                <li>High risk alerts delivered (coming soon)</li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <p>
                                More information on dashboards and reports is included in section 3.1 (Access Patient Data) and
                                section 4.x (XXXXXXXXX).
                            </p>
                        </div>
                        {/* )} */}
                    </div>
                    <hr></hr>

                    {/* ) */}

                    <div id="sec2" style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>
                        <h2 style={{ color: "#282a65", }}
                        >2. GETTING STARTED</h2>

                        <h3 style={{ color: "#282a65", }}
                        >2.1 Set Up Your Profile (for internal use)</h3>
                        <p>
                            Your MyJEEVA profile is used within the MyJEEVA solution to provide easy access to information about you
                            to your colleagues. The information in this section is not shared with patients or third parties.
                        </p>
                        <p>
                            To set up or update your profile, navigate to the <strong>About Me</strong> section on the left banner. The
                            <strong> View Profile</strong> view should be displayed by default. Click the <strong>Edit</strong> button in the
                            upper right-hand corner to add or modify the following information:
                        </p>
                        <ul>
                            <li>Your name</li>
                            <li>Contact phone number</li>
                        </ul>
                        <p>
                            Your position within the organization and email address are not editable. Those profile properties are
                            determined by the Administrator who onboarded you.
                        </p>
                        <p>
                            You may also change your MyJEEVA Provider Portal password by clicking on the
                            <strong> Change Password</strong> button in the upper right-hand corner.
                        </p>

                        <h3 style={{ color: "#282a65", }}
                        >2.2 Update External Contact Information (for patient use)</h3>
                        <p>
                            Your external contact information is used within the MyJEEVA patient application to provide patients a quick and
                            easy way to contact your office in the event of an urgent question or medical situation. The information in this
                            section is only shared with patients – never third parties.
                        </p>
                        <p>
                            To set up or update your external contact information, navigate to the <strong>About Me</strong> section on the left
                            banner and click on the <strong>Contact Information</strong> tab in the upper left section. Click the <strong>Edit</strong>
                            button in the upper right-hand corner to add or modify the following information:
                        </p>

                        <h4>Data Columns</h4>
                        <table border="1" cellPadding="10" style={{ borderCollapse: 'collapse', width: '100%' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th>Data Column</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Description</td>
                                    <td>Label used in the MyJEEVA patient application to describe the presented contact information. Typically “Business hours contact information” or “After hours contact information.”</td>
                                </tr>
                                <tr>
                                    <td>Contact Number</td>
                                    <td>Phone number a patient should call during the defined time period.</td>
                                </tr>
                                <tr>
                                    <td>Address</td>
                                    <td>Address a patient should go to for medical care during the defined time period.</td>
                                </tr>
                                <tr>
                                    <td>Start Time</td>
                                    <td>Starting time of the day applicable to the defined time period.</td>
                                </tr>
                                <tr>
                                    <td>End Time</td>
                                    <td>Ending time of day applicable to the defined time period.</td>
                                </tr>
                                <tr>
                                    <td>From Weekday</td>
                                    <td>First day of the week applicable to the defined time period.</td>
                                </tr>
                                <tr>
                                    <td>To Weekday</td>
                                    <td>Last day of the week applicable to the defined time period.</td>
                                </tr>
                                <tr>
                                    <td>Is Default</td>
                                    <td>Delineates whether “Business hours” or “After hours” tab is shown by default in the patient application.</td>
                                </tr>
                                <tr>
                                    <td>Time Zone</td>
                                    <td>Time zone of the defined time period.</td>
                                </tr>
                                <tr>
                                    <td>Type</td>
                                    <td>Delineates whether the defined time period is Business hours or After hours.</td>
                                </tr>
                            </tbody>
                        </table>

                        <h3 style={{ color: "#282a65", }}
                        >2.3 Create Treatment Passphrases</h3>
                        <p><strong>Note – Treatment passphrases are completely optional</strong></p>
                        <p>There are two mechanisms to onboard patients to a MyJEEVA treatment:</p>
                        <ul>
                            <li><strong>QR code:</strong> A graphical code that can be scanned from within a patient’s MyJEEVA application.</li>
                            <li>
                                <strong>Treatment passphrase:</strong> A sequence of words or other text that's used to authenticate a treatment.
                                Passphrases are similar to passwords.
                            </li>
                        </ul>
                        <p>
                            Unique treatment QR codes are generated for each provider-treatment combination. However, if you wish to use
                            passphrases, they must be uniquely generated by the provider.
                        </p>

                        <h4>To create treatment passphrases:</h4>
                        <ol>
                            <li>Go to the <strong>Engagement</strong> tab on the left ribbon. If you are logged in with the Provider role, the page will default to Treatment view.</li>
                            <li>Find the treatment you wish to edit and click on the <strong>Key</strong> button in the Patient Onboarding column.</li>
                            <li>Enter the desired passphrase and hit the <strong>Save</strong> button.</li>
                            <li>Repeat the process for each available treatment you plan to use.</li>
                        </ol>

                        <h4>Tip – For proper function and security:</h4>
                        <ul>
                            <li>Each passphrase must be unique.</li>
                            <li>Passphrases should have at least 4 random words and be 15 characters long in total length.</li>
                        </ul>
                    </div>
                    <hr></hr>

                    <div id="sec3" style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>
                        <h2 style={{ color: "#282a65", }}
                        >3. ENGAGE PATIENTS</h2>

                        <h3>Onboard Patients</h3>
                        <p>
                            <strong>TIP –</strong> Patients only need to be onboarded to MyJEEVA once. Subsequent treatments can be added
                            without repeating the onboarding process.
                        </p>

                        <p>Patients should be onboarded to MyJEEVA as soon as:</p>
                        <ul>
                            <li>There is an appropriate MyJEEVA treatment available to address the patient's medical needs, and</li>
                            <li>There is medical benefit to the patient provided by the treatment's library or risk management.</li>
                        </ul>

                        <p>
                            Ideally, the patient will be approaching the first phase of the healthcare journey incorporated into the
                            treatment library, but patient onboarding can take place at any time.
                        </p>

                        <h4>To onboard a patient, the patient should follow these six steps:</h4>
                        <ol>
                            <li>
                                Download the MyJEEVA application from the Apple App Store or Google Play Store.
                            </li>
                            <li>
                                Create a MyJEEVA account. This requires the patient's name (should match the name used in medical records),
                                an email address, and a password.
                            </li>
                            <li>
                                Check the email account and copy over the 6-digit confirmation code to the MyJEEVA application.
                            </li>
                            <li>
                                Accept the patient <strong>Terms of Use, Privacy Policy,</strong> and <strong>Artificial Intelligence Policy</strong>.
                            </li>
                            <li>
                                The application will then go directly to a screen where the patient can scan a treatment QR code or enter a
                                treatment passphrase by clicking on the key icon located towards the top of the page.
                            </li>
                            <li>
                                <strong>Optional:</strong> Provide the patient with a printed-out copy of the <strong>Patient Onboarding Document</strong>.
                                This document will answer many of the questions patients typically have during the onboarding process. An electronic
                                copy of the onboarding document is also accessible in the MyJEEVA application by clicking the help icon in the upper
                                left corner of the screen.
                            </li>
                        </ol>

                        <p>
                            <strong>TIP –</strong> Providers can present QR codes and/or passphrases to patients through multiple mechanisms:
                        </p>
                        <ul>
                            <li>
                                Display the QR code directly from the MyJEEVA Provider Portal screen (there is no ePHI on the Engagements tab).
                            </li>
                            <li>
                                Create a cheat sheet by taking screenshots of provider- and treatment-specific QR codes and/or passphrases.
                            </li>
                            <li>
                                Modify the MyJEEVA Patient Onboarding Document to include the appropriate QR code. If you take this approach, make
                                sure the document is labeled so that documents for different providers and treatments aren’t inadvertently mixed together.
                            </li>
                        </ul>

                        <h3>Assign Additional Treatments to Patients</h3>
                        <p>
                            There are two mechanisms to onboard patients to a MyJEEVA treatment. Only one mechanism is required, and providers
                            may use whichever fits their workflows the best.
                        </p>
                        <ul>
                            <li>
                                <strong>QR code:</strong> A graphical code that can be scanned from within a patient’s MyJEEVA application.
                            </li>
                            <li>
                                <strong>Treatment passphrase:</strong> A sequence of words or other text that's used to authenticate a treatment.
                                Passphrases are similar to passwords.
                            </li>
                        </ul>

                        <p><strong>To add the additional treatment, the patient navigates</strong></p>
                        <p>The process to onboard a patient and add the first treatment is</p>
                        <blockquote>“Xxxxxxxxxxxxxxxx”</blockquote>

                        <h3>Access Patient Data</h3>
                        <p>Patient-specific data can be accessed</p>

                        <h3>Add Patient Milestone Dates</h3>
                        <p>Select milestone, add date</p>
                        <p>Multiple instances of a milestone may be added for the same patient.</p>
                    </div>
                    <hr></hr>

                    <div id="sec4" style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>
                        <h2 style={{ color: "#282a65", }}
                        >4. IDENTIFY PATIENTS AT RISK</h2>
                    </div>
                    <hr></hr>

                    <div id="sec5" style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>
                        <h2 style={{ color: "#282a65", }}
                        >5. CREATE OR MODIFY A TREATMENT</h2>

                        <h3>Treatment Creation Overview</h3>
                        <p>
                            Creation of a treatment within MyJEEVA is a straightforward process. The first iteration of a treatment can
                            generally be completed within a few hours and is iterated over time based on provider and patient feedback.
                        </p>

                        <h3>How to Select a Treatment to Create</h3>
                        <ul>
                            <li>Moderate to high volume</li>
                            <li>Impactful</li>
                            <li>Understanding of and compliance with instructions impacts complications</li>
                            <li>Known leading indicator of at-home complications</li>
                        </ul>

                        <h3>Populate Treatment Library Content</h3>
                        <ul>
                            <li>Collect existing content</li>
                            <li>Establish logical content tree-structure</li>
                            <li>Identify appropriate graphics</li>
                            <li>Create the treatment within MyJEEVA</li>
                            <li>Populate existing content into the library tree-structure</li>
                            <li>Modify the order of content as appropriate</li>
                        </ul>

                        <h3>Define Risk Parameters</h3>
                        <ul>
                            <li>What are the most common complications you want to prevent?</li>
                            <li>When are the complications most likely to happen?</li>
                            <li>What bio-markers and/or psycho-markers are leading indicators of a serious complication?</li>
                        </ul>

                        <h3>Create Milestones</h3>
                        <p>
                            Milestones are used to create time-based dependencies for journals, surveys, and risk rules.
                            Examples include:
                        </p>
                        <ul>
                            <li>Sending a survey to a patient 3 days before an operation</li>
                            <li>Enabling a set of journals for 10 days after an operation</li>
                            <li>Enabling a journal to monitor biomarkers for 14 days after a complication</li>
                        </ul>

                        <h3>Create Journals</h3>
                        <p>
                            Digital, provider-defined journals enable patients to document their recovery journey over a period of time.
                            Journals can be configured to document bio-markers and/or psycho-markers.
                        </p>

                        <h3>Create Surveys</h3>
                        <p>
                            Digital, provider-defined surveys enable patients to provide feedback about their recovery journey at a
                            point-in-time. Surveys are answered once by a patient and entries are reflected in the MyJEEVA Provider Portal
                            in real-time.
                        </p>

                        <h3>Create Risk Rules</h3>
                        <p>
                            Risk rules help define thresholds for patient conditions, allowing providers to take action based on data
                            insights.
                        </p>
                    </div>
                    <hr></hr>

                    <div id="sec6" style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>
                        <h2 style={{ color: "#282a65", }}
                        >6. For MyJEEVA Administrators</h2>

                        <h3>Onboarding and Removing Users</h3>

                        <h4>To Onboard a New User</h4>
                        <ul>
                            <li>Navigate to the MyJEEVA Administrator Portal.</li>
                            <li>Click on the "Add User" button.</li>
                            <li>Enter the user’s name, email, and role.</li>
                            <li>Send an invitation email with account setup instructions.</li>
                            <li>Once the user completes registration, they gain access to their assigned permissions.</li>
                        </ul>

                        <h4>To Remove an Existing User</h4>
                        <ul>
                            <li>Go to the MyJEEVA Administrator Portal.</li>
                            <li>Search for the user by name or email.</li>
                            <li>Select the user and click "Remove".</li>
                            <li>Confirm the removal to revoke their access.</li>
                        </ul>

                        <h3>Assigning Treatments</h3>
                        <p>
                            After a Provider is onboarded, Service Line Administrators can assign treatments to them. The responsibility of user management
                            varies based on the administrator level.
                        </p>

                        <h4>Service Line Administrators</h4>
                        <ul>
                            <li>Invite and remove Providers and other Service Line Administrators.</li>
                            <li>Create default Service Line (SL) treatments.</li>
                        </ul>

                        <h4>Hospital Administrators</h4>
                        <ul>
                            <li>Invite and remove Service Line Administrators and other Hospital Administrators.</li>
                        </ul>

                        <h4>Health System Administrators</h4>
                        <ul>
                            <li>Invite and remove Health System (HS) Administrators and other HS Administrators.</li>
                        </ul>
                    </div>
                    <hr></hr>

                    <div id="sec7" style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>
                        <h2 style={{ color: "#282a65", }}
                        >7. Technical Requirements</h2>
                        <p>
                            Use of the MyJEEVA Provider Portal requires a desktop or laptop computer running Windows or macOS,
                            internet access, and a supported browser.
                        </p>
                        <h4>Supported Browsers:</h4>
                        <ul>
                            <li>Google Chrome (latest version)</li>
                            <li>Safari (latest version)</li>
                        </ul>
                        <p>
                            If a non-supported browser is used to access the MyJEEVA Provider Portal,
                            some or all functionality may be degraded or inoperable.
                        </p>
                        <p>
                            📌 **Note:** MyJEEVA Provider Portal is not currently supported on smartphones or tablets.
                        </p>

                    </div>
                    <hr></hr>

                    <div id="sec8" style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>
                        <h2 style={{ color: "#282a65", }}
                        >8. Support</h2>
                        <p>
                            If you require support, please contact MyJEEVA Customer Support at:
                            <br />
                            📧 <strong>support@jeevecare.com</strong>
                            <br />
                            📞 <strong>+1 (800) 555-1234</strong>
                        </p>

                    </div>
                    <hr></hr>

                    <div id="sec9" style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>

                        <h2 style={{ color: "#282a65", }}
                        >9. Copyright and Legal Notices</h2>
                        <p>Copyright © 2025 JEEVA Care, Inc.</p>
                        <p>
                            <strong>JEEVA Care, Inc.</strong>
                            <br />
                            3442 Magnolia Shores Lane
                            <br />
                            Pearland, TX  77584
                        </p>
                        <p>
                            All rights reserved. This documentation and the MyJEEVA solution are protected by U.S. and
                            international copyright and intellectual property laws.
                        </p>
                        <p>
                            MyJEEVA documentation is believed to be materially accurate and complete. The MyJEEVA service
                            and documentation are provided “as is” without warranty or guarantee of performance or fitness
                            for any particular purpose.
                        </p>
                        <p>
                            The provision of this solution does not grant any rights to use the solution. All usage is
                            subject to the SaaS agreement between the Provider and JEEVA Care, MyJEEVA Provider Portal
                            Terms of Service, Acceptable Use Policy, and Privacy Policy.
                        </p>
                        <p>© 2025 JEEVA Care, Inc. All rights reserved.</p>
                    </div>
                    <hr></hr>

                </div>
            </div >
        );
    }
}

export default ProviderPortalDoc;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ProviderPortalDoc.js